<template>
    <section class="main-view">
        <div class="container-scroller">
            <Header />
            <div class="container-fluid page-body-wrapper client-dashbboard">
                <SettingsPannel></SettingsPannel>
                <Sidebar />
                <div class="main-panel">
                    <div class="content-wrapper">
                        <router-view></router-view>
                    </div>
                </div>
                <!-- main panel ends -->
            </div>
            <!-- page-body-wrapper ends -->
        </div>
    </section>
</template>

<script>
import Header from "./partials/Header";
import Sidebar from "./partials/Sidebar";
import SettingsPannel from "./partials/SettingsPannel";

export default {
    name: "layout",
    components: {
        Header,
        Sidebar,
        SettingsPannel
    }, data() {
        return {
            getPermissionsData: [],
        };
    }, beforeMount() {
        this.getPermissions();
    }, mounted() {
    }, methods: {
        getPermissions() {
            this.getPermissionsData = JSON.parse(localStorage.getItem('userPermissions'));
        },
        permissionExist(param) {
            var check = this.getPermissionsData.includes(param);
            if (check) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>
<style scoped></style>
